(() => {
  /**
   * Uses Swiper package to create a carousel
   * More info: https://swiperjs.com/
   */
  if (customElements.get('hero-slider')) {
    return;
  }

  class HeroSlider extends HTMLElement {
    constructor() {
      super();
      this.slider = null;
      this.options = {
        slidesPerView: 1,
        pagination: {
          el: this.querySelector('[data-pagination]'),
          type: 'bullets',
          clickable: true,
        },
      };

      if (this.hasAttribute('data-autoplay')) {
        this.options.autoplay = {
          delay: Number(this.getAttribute('data-autoplay')),
        };
      }
    }

    /**
     * Init slider.
     *
     * @returns {Void}
     */
    initSlider() {
      this.slider = new Swiper(this.sliderElement, this.options);
    }

    /**
     * Connected callback.
     *
     * @returns {Void}
     */
    connectedCallback() {
      this.sliderElement = this.querySelector('[data-slider]');

      if (!this.sliderElement) {
        return;
      }

      this.initSlider();
    }
  }

  customElements.define('hero-slider', HeroSlider);
})();
